import { render, staticRenderFns } from "./PreviewTab.vue?vue&type=template&id=651bdc0c&"
import script from "./PreviewTab.vue?vue&type=script&lang=js&"
export * from "./PreviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports